import { metrics__get_category_stats, metrics__get_top_communes } from 'common/src/api/metrics';

export interface CategoryStats {
  category: string;
  instance_count: number;
  total_sales: number;
}

export interface CommuneStats {
  commune: string;
  task_count: number;
  revenue: number;
  revenue_percentage: number;
}

export const fetchCategoryStats = async (
  startDate: string,
  endDate: string
): Promise<CategoryStats[]> => {
  try {
    const { data, error } = await metrics__get_category_stats(startDate, endDate);
    if (error) {
      console.error('Error fetching category stats:', error);
      throw new Error(`Failed to fetch category stats: ${error.message}`);
    }

    return data || [];
  } catch (err) {
    console.error('Unexpected error in fetchCategoryStats:', err);
    throw err;
  }
};

export const fetchTopCommunes = async (
  startDate: string,
  endDate: string
): Promise<CommuneStats[]> => {
  try {
    const { data, error } = await metrics__get_top_communes(startDate, endDate);
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching top communes:', error);
    throw error;
  }
};
